import { createFileRoute } from "@tanstack/react-router";
import InventoryLab from "@/pages/InventoryLab";

export const Route = createFileRoute("/rv-search-lab")({
  component: InventoryLab,
});
